Number.prototype.padStart = function (...args) {
    if (!this)
        return ''.padStart(...args);
    return this.toString().padStart(...args);
};
Number.prototype.padEnd = function (...args) {
    if (!this)
        return ''.padEnd(...args);
    return this.toString().padEnd(...args);
};
Number.prototype.toCurrency = function (currency, sign = true, decimals = 2, force) {
    if (sign === 'all')
        sign = true;
    let num = Number.isNaN(this) ? 0 : this;
    let numb = Intl.NumberFormat('es', {
        maximumFractionDigits: decimals,
        minimumFractionDigits: decimals,
        minimumIntegerDigits: 1,
    }).format(num);
    if (sign === true || sign === 'signOnly') {
        if (currency && currency.Sign)
            numb = currency.Sign + ' ' + numb;
        else
            numb = '$ ' + numb;
    }
    if (sign === true || sign === 'prefixOnly') {
        if (currency && currency.Prefix)
            numb = currency.Prefix + ' ' + numb;
        if (force && currency && currency.ForcePrefix)
            numb = currency.ForcePrefix + ' ' + numb;
    }
    return numb;
};
Number.prototype.toRate = function (n = 2, multiply) {
    let num = Number.isNaN(this) ? 0 : this;
    let numb = Intl.NumberFormat('es', {
        maximumFractionDigits: n,
        minimumFractionDigits: n,
        minimumIntegerDigits: 1,
    }).format(multiply ? (num * 100) : num);
    return numb + '%';
};
Number.prototype.toDecimal = function (n = 2, max = 0) {
    let num = Number.isNaN(this) ? 0 : this;
    let numb = Intl.NumberFormat('es', {
        maximumFractionDigits: max > 0 ? max : n,
        minimumFractionDigits: n,
        minimumIntegerDigits: 1,
    }).format(num);
    return numb;
};
Number.prototype.NumberFormat = function (locale = 'es', opt = { maximumFractionDigits: 2, minimumFractionDigits: 2, minimumIntegerDigits: 1 }) {
    let num = Number.isNaN(this) ? 0 : this;
    return Intl.NumberFormat(locale, opt).format(num);
};
Number.prototype.round = function (n = 0) {
    let num = Number.isNaN(this) ? 0 : this;
    return Number(num.toFixed(n));
};
Number.prototype.isNan = function () {
    return isNaN(Number(this));
};
